import { TFeatureFlag, TUser } from "@/types";

import { useAuth } from "./useAuth";

/**
 * Whether a feature exists for this user (`/me` → features, from the
 * API's feature_flags). Off when unknown: a paused feature stays hidden
 * rather than flashing in. Not the plan's say - PlanGate is that.
 */
export const isFeatureOn = (
	user: TUser | null | undefined,
	feature: TFeatureFlag
): boolean => !!user?.features?.[feature];

export const useFeatureFlag = (feature: TFeatureFlag): boolean => {
	const { user } = useAuth();
	return isFeatureOn(user, feature);
};
